import { z } from 'zod'

/**
 * Mirrors `Budget/Models/GoalModels.swift`.
 *
 * V1 of the web UI only exposes `target_by_date` because that's the
 * most common YNAB-style goal ("save $X by Y"). The schema below
 * still admits all three iOS types so a future UI rev (or an iOS
 * write) round-trips through the web client cleanly.
 *
 * Persistence: `users/{uid}/goals/{goalId}`. iOS hasn't wired
 * persistence yet (GoalsManager has a TODO) — when it does it
 * should adopt this same shape.
 */

export const GoalTypeSchema = z.enum(['target_by_date', 'monthly_contribution', 'spend_target'])
export type GoalType = z.infer<typeof GoalTypeSchema>

export const GoalSchema = z.object({
  id: z.string().uuid(),
  categoryId: z.string().uuid(),
  type: GoalTypeSchema,
  // ISO-8601 string matching iOS .iso8601 dateEncodingStrategy.
  createdDate: z.string(),
  isCompleted: z.boolean().default(false),
  completedDate: z.string().nullable().optional(),
  targetAmount: z.number().nullable().optional(),
  targetDate: z.string().nullable().optional(),
  monthlyContribution: z.number().nullable().optional(),
  note: z.string().nullable().optional(),
})
export type Goal = z.infer<typeof GoalSchema>
